import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	useActiveRightSidebarState,
	useRightSidebarController,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { AsyncAiRovoPanel } from './async.tsx';

const JIRA_ROVO_AI_CONTAINER_ID = 'jira-rovo-ai-container';

const RovoPanelSidebar = () => {
	const { closeCurrentRightSidebar } = useRightSidebarController();
	const rightSidebarCurrentState = useActiveRightSidebarState();

	if (rightSidebarCurrentState?.panelId !== JIRA_ROVO_AI_CONTAINER_ID) {
		return null;
	}

	return <AsyncAiRovoPanel onClosePanel={closeCurrentRightSidebar} />;
};

export const SafeRovoPanelSidebar = () => (
	<JSErrorBoundary
		fallback="unmount"
		id="right-side-rovo-side-panel"
		packageName="jiraRovoSidePanel"
	>
		<RovoPanelSidebar />
	</JSErrorBoundary>
);
